export function buildEntityPathSegment(entity: string): string {
  return encodeURIComponent(entity.trim());
}
